module.exports = __webpack_public_path__ + "static/media/img-kakao-banner@2x.ead26342.png";